import $ from 'jquery';
import BaseView from '../core/baseView';

/**
 * message about cookie policy
 */
export default BaseView.extend({
  events: {
    'click .js-cookie-message__button': 'onCloseClick'
  },

  onCloseClick: function(event) {
    $.ajax({
      type: 'GET',
      url: $(event.currentTarget).data('href')
    });
    this.$el.addClass('is-hidden');
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/cookieMessageView.js
 **/